import QueryConstraint from 'owa-calendar-scheduling-service/lib/schema/QueryConstraint';

/**
 * Create QueryConstraint for FML request
 */
export default function createQueryConstraints(
    queryString: string,
    placeId: string,
    isAvailabilityRequested: boolean,
    requestAvailableConferenceRoomsOnly: boolean,
    requestRoomOnly: boolean
): QueryConstraint {
    if (placeId != null) {
        return {
            Id: placeId,
        } as QueryConstraint;
    }

    let queryConstraint: QueryConstraint = {
        Query: queryString,
    } as QueryConstraint;

    if (requestAvailableConferenceRoomsOnly) {
        queryConstraint.AvailableConferenceRoomsOnly = true;
    }

    if (requestRoomOnly) {
        queryConstraint.ConferenceRoomsOnly = true;
    }

    return queryConstraint;
}
